import { useLanguage } from '../i18n';

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  return (
    <div className="language-switcher" role="group" aria-label="Language">
      <button
        className={`lang-btn${language === 'en' ? ' active' : ''}`}
        onClick={() => setLanguage('en')}
        aria-pressed={language === 'en'}
      >
        EN
      </button>
      <span className="lang-divider">|</span>
      <button
        className={`lang-btn${language === 'fr' ? ' active' : ''}`}
        onClick={() => setLanguage('fr')}
        aria-pressed={language === 'fr'}
      >
        FR
      </button>
    </div>
  );
}
